var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmedPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4663_54220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 8C15.4286 8 9 14.4286 9 22.2857C9 26 10.4286 29.7143 13.1429 32.4286L22.2857 41.8571C22.8571 42.4286 23.7143 42.4286 24.2857 41.8571L33.2857 32.4286C36.1429 29.7143 37.5714 26.1429 37.5714 22.2857C37.5714 14.4286 31.1429 8 23.2857 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 7.25C31.5573 7.25023 38.3213 14.0149 38.3213 22.2861C38.3212 26.3369 36.8171 30.1089 33.8027 32.9727L24.8281 42.375L24.8223 42.3809L24.8164 42.3877C23.9522 43.2519 22.6202 43.2517 21.7559 42.3877L21.7471 42.3789L12.6123 32.958C9.74996 30.0954 8.25011 26.1875 8.25 22.2861C8.25 14.0148 15.0148 7.25 23.2861 7.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4663_54220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7751 29.6583C23.6657 29.6583 22.5594 29.6646 21.4501 29.6521C21.2782 29.6489 21.0938 29.5802 20.9344 29.4958C20.1407 29.0177 19.5094 28.3614 19.5688 27.3427C19.6219 25.5333 19.5876 23.7208 19.5813 21.9083C19.5782 21.5052 19.7282 21.2021 20.0251 20.9333C22.0876 19.1302 23.5032 17.8864 23.7469 14.9864C24.0626 13.6271 25.9126 14.5614 25.9844 15.6146C26.5219 17.9146 24.7063 20.0396 25.7126 19.9458C26.9376 19.9896 28.1626 20.0302 29.3876 20.0708C30.2938 20.0989 31.0282 20.8833 31.0032 21.9083C30.8563 23.8927 30.4438 25.8614 30.2438 27.8427C29.8094 30.4083 26.6188 29.4927 24.7751 29.6583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.55 20.8242H18.25C18.5531 20.8242 18.8 21.0711 18.8 21.3742V29.0086C18.8 29.3117 18.5531 29.5586 18.25 29.5586H15.55C15.2469 29.5617 15 29.3148 15 29.0086V21.3773C15 21.0711 15.2469 20.8242 15.55 20.8242Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4663_54220",
    x: 0.7,
    y: 0.7,
    width: 45.1713,
    height: 50.8852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4663_54220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4663_54220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4663_54220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedPinIcon);
export default __webpack_public_path__ + "static/media/ConfirmedPinIcon.1cf34327bf6c29d28775243b42e32cc5.svg";
export { ForwardRef as ReactComponent };